import { Component, input, output } from '@angular/core';
import { Modal } from 'flowbite';
import { AnimationOptions } from 'ngx-lottie';
import { SetupUpdateOptions } from 'src/app/models';
import { TicketingType } from 'src/app/models/enums';
import { LiteralService, UtilsService } from 'src/app/services';
import { images } from 'src/images';

@Component({
  selector: 'app-modal-confirm-setup-update',
  templateUrl: './modal-confirm-setup-update.component.html',
  styleUrl: './modal-confirm-setup-update.component.scss',
  standalone: false
})
export class ModalConfirmSetupUpdateComponent {

  readonly id = input<string>();
  readonly modal = input<Modal>();
  readonly hasScheduleUpdates = input<boolean>(false);
  readonly hasScheduleDeletes = input<boolean>(false);
  readonly hasDateChanges = input<boolean>(false);
  readonly ticketingType = input<TicketingType>();
  readonly roundTrips = input<boolean>(false);
  readonly updating = input<boolean>(false);
  readonly action = output<SetupUpdateOptions>();

  public images = images;

  // Update options
  public applyToAvailabilities = false;
  public updateTrips = false;
  public sendNotificationUpdate = false;

  // Delete options
  public deleteOrphanedAvailabilities = false;
  public deleteComment = '';
  public sendNotificationDelete = true;
  public refund = true;
  public cancelRelated = true;
  public fullRefund = false;

  public loadingAnimation: AnimationOptions = {
    path: '/assets/animations/bus.json'
  };

  constructor(public literalService: LiteralService, public utilsService: UtilsService) {}

  get showUpdateSection(): boolean {
    return this.hasScheduleUpdates();
  }

  get showDeleteSection(): boolean {
    return this.hasScheduleDeletes() || this.hasDateChanges();
  }

  get showRefundOptions(): boolean {
    return this.ticketingType() === TicketingType.Hybrid || this.ticketingType() === TicketingType.Online;
  }

  get showCancelRelated(): boolean {
    return this.roundTrips();
  }

  onSubmit() {
    this.action.emit({
      applyToAvailabilities: this.applyToAvailabilities,
      updateTrips: this.applyToAvailabilities ? this.updateTrips : false,
      sendNotification: this.applyToAvailabilities ? this.sendNotificationUpdate : (this.deleteOrphanedAvailabilities ? this.sendNotificationDelete : false),
      deleteOrphanedAvailabilities: this.deleteOrphanedAvailabilities,
      deleteComment: this.deleteOrphanedAvailabilities ? this.deleteComment : '',
      refund: this.deleteOrphanedAvailabilities && this.showRefundOptions ? this.refund : false,
      cancelRelated: this.deleteOrphanedAvailabilities && this.showCancelRelated ? this.cancelRelated : false,
      fullRefund: this.deleteOrphanedAvailabilities && this.showRefundOptions ? this.fullRefund : false
    });
  }

  changeToggleApplyToAvailabilities() {
    this.applyToAvailabilities = !this.applyToAvailabilities;
    if (!this.applyToAvailabilities) {
      this.updateTrips = false;
      this.sendNotificationUpdate = false;
    } else {
      this.updateTrips = true;
      this.sendNotificationUpdate = true;
    }
  }

  close() {
    this.modal()?.hide();
    this.resetForm();
  }

  private resetForm() {
    this.applyToAvailabilities = false;
    this.updateTrips = true;
    this.sendNotificationUpdate = true;
    this.deleteOrphanedAvailabilities = false;
    this.deleteComment = '';
    this.sendNotificationDelete = true;
    this.refund = true;
    this.cancelRelated = true;
    this.fullRefund = false;
  }
}
